import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['minimized', 'maximized'];
  static classes = ['expanded'];
  static values = {
    remember: String,
    initialDesktop: { type: String, default: 'max' },
    initialMobile: { type: String, default: 'min' },
  };
  mobileView = 768;

  connect() {
    let state = this.getInitialState();
    state = this.getRememberedValue() ? this.getRememberedValue() : state;
    state === 'max' ? this.maximize() : this.minimize();
  }

  getRememberedValue() {
    return this.rememberValue && localStorage.getItem(this.rememberValue);
  }

  setRemeberValue(value) {
    this.rememberValue && localStorage.setItem(this.rememberValue, value);
  }

  getInitialState() {
    return this.isMobileView() ? this.initialMobileValue : this.initialDesktopValue;
  }

  isMobileView() {
    this.initialMobileValue && window.innerWidth < this.mobileView;
  }

  maximize() {
    this.setRemeberValue('max');
    this.maximizedTarget.classList.remove('max-h-0');
    this.maximizedTarget.classList.add(...this.expandedClasses);
    this.minimizedTarget.classList.add('hidden');
  }

  minimize() {
    this.setRemeberValue('min');
    this.maximizedTarget.classList.add('max-h-0');
    this.maximizedTarget.classList.remove(...this.expandedClasses);
    //Adding a small time out here so the css animation is smoother.
    setTimeout(() => {
      this.minimizedTarget.classList.remove('hidden');
    }, 50);
  }
}
